import { MemberDrawer } from '@bo-components/members/drawer';
import { MemberPromotionDrawerContext } from '@bo-hooks/members';
import { MemberPromotionDrawerDetails } from '@bo-components/members/memberPromotions';
import { useContext } from 'react';

export const MemberPromotionDrawer = () => {
  const { onClosePromotionsDrawer } = useContext(MemberPromotionDrawerContext);

  return (
    <MemberDrawer isOpen onCloseDrawer={onClosePromotionsDrawer}>
      <MemberPromotionDrawerDetails />
    </MemberDrawer>
  );
};
